import { render, staticRenderFns } from "./ClientRecorsTable.vue?vue&type=template&id=10e1db6d&scoped=true"
import script from "./ClientRecorsTable.vue?vue&type=script&lang=js"
export * from "./ClientRecorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e1db6d",
  null
  
)

export default component.exports